module.exports = __webpack_public_path__ + "static/media/day_four.e3a7ccf1.jpeg";